module.exports = __webpack_public_path__ + "static/img/picture5.e5ab8cd8.png";